<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h2>{{ gui ? gui.dealers : '' }}</h2>
        </b-col>
      </b-row>

      <b-row class="my-2">
        <b-col>
          <b-alert show variant="info" class="mb-0 py-2">
            <ul class="mb-0">
              <li>A alteração é <strong>imediata</strong> — sem necessidade de sincronizar a maquininha.</li>
              <li><strong>Modo Texto</strong> trafega menos dados; <strong>Modo Imagem</strong> trafega mais pois a impressão é 100% imagem.</li>
              <li><strong>Modo Texto Nativo</strong> é compatível apenas com maquininhas <strong>Sunmi</strong>.</li>
              <li>Em redes instáveis, acesse as Configurações Avançadas para omitir a logo e reduzir o volume de dados.</li>
              <li><strong>Múltiplas formas de pagamento</strong> só vale no modo de venda <strong>Reservar e resgatar</strong>.</li>
            </ul>
          </b-alert>
        </b-col>
      </b-row>

      <b-row class="my-4">
        <b-col cols="12" md="6">
          <b-form inline>
            <label class="mr-2">Configurar todos modos de impressão como:</label>
            <b-form-select
              v-model="bulkPrintMode"
              :options="printModeOptions"
              class="mr-2 mt-2"
              style="width: auto"
            />
            <b-button variant="primary" @click="confirmBulkUpdate">Configurar todos</b-button>
          </b-form>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-table
            :items="dealers"
            :fields="fields"
            striped
            hover
            responsive
          >
            <template v-slot:cell(print_mode)="data">
              <b-form-select
                v-model="data.item.print_mode"
                :options="printModeOptions"
                style="width: auto"
                @change="updateDealerPrintMode(data.item.id, data.item.print_mode)"
              />
            </template>
            <template v-slot:cell(sell_mode)="data">
              <b-form-select
                v-model="data.item.sell_mode"
                :options="sellModeOptions"
                style="width: auto"
                @change="updateDealerSellMode(data.item.id, data.item.sell_mode)"
              />
            </template>
            <template v-slot:cell(multiple_payment_methods_enabled)="data">
              <span :title="data.item.sell_mode !== 'reserve_and_claim' ? 'Vale só no modo de venda Reservar e resgatar.' : ''">
                <toggle-button
                  :value="data.item.multiple_payment_methods_enabled"
                  :sync="true"
                  :disabled="data.item.sell_mode !== 'reserve_and_claim'"
                  :width="45"
                  :height="25"
                  :color="{checked: '#26A65B', unchecked: '#E74C3C'}"
                  @change="updateDealerMultiplePaymentMethods(data.item, $event.value)"
                />
              </span>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Gui from '@/gui'
import ToggleButton from 'vue-js-toggle-button/src/Button'

export default {
  name: 'AdminListDealers',
  components: {
    ToggleButton
  },
  data () {
    return {
      gui: null,
      eventId: null,
      dealers: [],
      bulkPrintMode: 'go-png',
      fields: [
        { key: 'name', label: 'Nome' },
        { key: 'print_mode', label: 'Modo de impressão' },
        { key: 'sell_mode', label: 'Modo de venda' },
        { key: 'multiple_payment_methods_enabled', label: 'Múltiplas formas de pagamento' }
      ],
      printModeOptions: [
        { value: 'sdk-sunmi', text: '✅ Modo Texto Nativo' },
        { value: 'dantsu', text: '🔄 Modo Texto Genérico' },
        { value: 'go-png', text: '✅ Modo Imagem Otimizado' },
        { value: 'wk-png', text: '⚠️ Modo Imagem Antigo' }
      ],
      sellModeOptions: [
        { value: 'unit', text: 'Unitário' },
        { value: 'reserve_and_claim', text: 'Reservar e resgatar' }
      ]
    }
  },
  async mounted () {
    this.eventId = this.$route.params.id
    await this.loadDealers()
  },
  methods: {
    async loadDealers () {
      try {
        const url = process.env.VUE_APP_URL_APP + `/b/admin/events/${this.eventId}/dealers`
        const resp = await this.$http.get(url)
        this.dealers = resp.body.dealers || []
        this.gui = new Gui(resp.body.event_type || 'evento')
      } catch (err) {
        console.error(err)
      }
    },
    async updateDealerPrintMode (dealerId, printMode) {
      try {
        const url = process.env.VUE_APP_URL_APP + `/b/admin/events/${this.eventId}/dealers/${dealerId}/print-mode`
        await this.$http.patch(url, { print_mode: printMode })
      } catch (err) {
        alert(err.body ? err.body.message : 'Erro ao atualizar modo de impressão')
        console.error(err)
        await this.loadDealers()
      }
    },
    async updateDealerSellMode (dealerId, sellMode) {
      try {
        const url = process.env.VUE_APP_URL_APP + `/b/admin/events/${this.eventId}/dealers/${dealerId}/sell-mode`
        await this.$http.patch(url, { sell_mode: sellMode })
      } catch (err) {
        alert(err.body ? err.body.message : 'Erro ao atualizar modo de venda')
        console.error(err)
        await this.loadDealers()
      }
    },
    async updateDealerMultiplePaymentMethods (dealer, enabled) {
      try {
        const url = process.env.VUE_APP_URL_APP + `/b/admin/events/${this.eventId}/dealers/${dealer.id}/multiple-payment-methods`
        await this.$http.patch(url, { multiple_payment_methods_enabled: enabled })
        dealer.multiple_payment_methods_enabled = enabled
      } catch (err) {
        alert(err.body ? err.body.message : 'Erro ao atualizar múltiplas formas de pagamento')
        console.error(err)
        await this.loadDealers()
      }
    },
    async confirmBulkUpdate () {
      const modeLabel = (this.printModeOptions.find(o => o.value === this.bulkPrintMode) || {}).text || this.bulkPrintMode
      const h = this.$createElement
      const action = await this.$bvModal.msgBoxConfirm(
        h('div', [
          'Todos os revendedores serão configurados para:',
          h('div', { class: 'font-weight-bold mt-1 mb-1' }, modeLabel),
          'A alteração é imediata. Deseja continuar?'
        ]),
        {
          title: '⚠ Atenção',
          okVariant: 'danger',
          cancelVariant: 'secondary',
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar',
          centered: true,
          hideHeaderClose: false
        }
      )
      if (action === false || !action) return
      try {
        const url = process.env.VUE_APP_URL_APP + `/b/admin/events/${this.eventId}/dealers/print-mode`
        await this.$http.patch(url, { print_mode: this.bulkPrintMode })
        await this.loadDealers()
      } catch (err) {
        alert(err.body ? err.body.message : 'Erro ao atualizar modo de impressão')
        console.error(err)
      }
    }
  }
}
</script>
